<template>
	<ChalkyUtilityModal
		class="view-modal-global-create default-modal"
		v-bind:class="stateClass"
		v-model="isVisible"
		v-on:hide="Handle_OnHide"
	>
		<ChalkyUtilitySlideshow
			ref="slideshowView"
			v-bind:showDots="false"
			v-bind:showNavigation="false"
			v-bind:slideCount="3"
			v-on:change="Handle_OnSlideChange"
		>
			<!-- Slide 0: Search + Confirm -->
			<template #slide-0>
				<header class="stepped-overlay-header">
					<h3>Mark it up</h3>
					<p>Create diagrams to share and practice with</p>
				</header>

				<section class="primary-container stepped-overlay-content">
					<!-- Content goes here -->
					<p>
						Tilt your device to landscape to access the Chalky Pad, where you can create and practice your
						own diagrams. You can also use the pad to follow along with coaches and teammates in real time.
					</p>
				</section>

				<section class="action-container stepped-overlay-actions">
					<div class="button-group">
						<button class="button-primary size-medium" v-on:click="Handle_OnClickNavigate">
							Start Creating
						</button>
					</div>
				</section>
			</template>

			<!-- Slide 1: Create -->
			<template #slide-1>
				<!-- Not implemented -->
			</template>

			<!-- Slide 2: Confirm -->
			<template #slide-2>
				<!-- Not implemented -->
			</template>
		</ChalkyUtilitySlideshow>
	</ChalkyUtilityModal>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * Global modal for creating new content.
	 * Provides a button to navigate to the Create page.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Modal/Global
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewModalGlobalCreate extends ViewBase {
		/**
		 * CSS state class for the modal.
		 *
		 * @return string
		 */
		public get stateClass(): string {
			return 'state-default';
		}

		/**
		 * Whether the modal is visible
		 *
		 * @type boolean
		 */
		protected isVisible: boolean = false;

		/**
		 * Attach event listeners on mount.
		 *
		 * @return void
		 */
		@mounted
		public attachEvents(): void {
			ChalkySticks.Core.Event.Bus.on('modal:create:open', this.Handle_OnOpen);
		}

		/**
		 * Detach event listeners before destroy.
		 *
		 * @return void
		 */
		@beforeDestroy
		public detachEvents(): void {
			ChalkySticks.Core.Event.Bus.off('modal:create:open', this.Handle_OnOpen);
		}

		/**
		 * Close the modal.
		 *
		 * @return void
		 */
		protected close(): void {
			this.isVisible = false;
		}

		/**
		 * Open the modal.
		 *
		 * @return void
		 */
		protected open(): void {
			this.isVisible = true;
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnOpen(): Promise<void> {
			this.open();
		}

		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnHide(): Promise<void> {
			this.close();
		}

		/**
		 * Navigate to the Create page.
		 *
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickNavigate(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.close();

			this.$router.push({
				name: 'PageCreate',
			});
		}

		// endregion: Event Handlers
	}
</script>
